import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    BookingReplacementState,
    BookingTeacherState,
    PlacementDetailsState,
} from '../firebase/types-bookings'
import { RootState } from './store'

type LoadingData<T> =
    | {
          loading: true
          state: undefined
      }
    | { loading: false; state: T }
interface IBookingSlice {
    teacherState: LoadingData<BookingTeacherState | null>
    placementState: LoadingData<PlacementDetailsState | null>
    replacementState: LoadingData<BookingReplacementState | null>
    autoreplaceSetting: LoadingData<boolean>
}
const initialState: IBookingSlice = {
    teacherState: {
        loading: true,
        state: undefined,
    },
    placementState: {
        loading: true,
        state: undefined,
    },
    replacementState: {
        loading: true,
        state: undefined,
    },
    autoreplaceSetting: {
        loading: true,
        state: undefined,
    },
}

const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        resetBookingSlice: () => {
            return initialState
        },
        setBookingTeacherState: (
            state,
            action: PayloadAction<BookingTeacherState | null>
        ) => {
            Object.assign(state.teacherState, {
                loading: false,
                state: action.payload,
            })
        },
        setBookingPlacementState: (
            state,
            action: PayloadAction<PlacementDetailsState | null>
        ) => {
            Object.assign(state.placementState, {
                loading: false,
                state: action.payload,
            })
        },
        setBookingReplacementState: (
            state,
            action: PayloadAction<BookingReplacementState | null>
        ) => {
            Object.assign(state.replacementState, {
                loading: false,
                state: action.payload,
            })
        },
        setBookingAutoreplaceSetting: (
            state,
            action: PayloadAction<boolean>
        ) => {
            Object.assign(state.autoreplaceSetting, {
                loading: false,
                state: action.payload,
            })
        },
    },
})

export const selectBookingTeacherState = (state: RootState) =>
    state.booking.teacherState
export const selectBookingPlacementState = (state: RootState) =>
    state.booking.placementState
export const selectBookingReplacementState = (state: RootState) =>
    state.booking.replacementState
export const selectBookingAutoreplaceSetting = (state: RootState) =>
    state.booking.autoreplaceSetting

export const {
    resetBookingSlice,
    setBookingPlacementState,
    setBookingTeacherState,
    setBookingReplacementState,
    setBookingAutoreplaceSetting,
} = bookingSlice.actions
export default bookingSlice.reducer
